import React from 'react';
import { Container} from 'react-bootstrap';
import styled from 'styled-components';
import Cards from '../../layout/CardsPreOperating';


const Styles = styled.div`
    .overlay {
        position: center;
    }
`;

export class PreOpMenu extends React.Component {



    render() {
        let auth = localStorage.getItem('user');        
        return (
            <React.Fragment>
            {
              !auth 
                 ?
                   this.props.history.push(`/`)
                 :
                <div>
            <Styles>
                <div className="overlay"></div>
                <Container>
                <Cards></Cards>
                </Container>
            </Styles>
            </div>
    }
    </React.Fragment>
        )
    }
}